/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneSafari } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/safari/add";
const editRoute = "/data/safari/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [safariList, setSafarisList] = useState([]);
  const { safari, safariCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  const [localSearch, setLocalSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.SAFARI,
  };

  useEffect(() => {
    if (!safari) fetchDoSeeData(data_request_body, page, pageSize);
    setSafarisList(safari);
  }, [safari]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];

    if (safari !== null && safari !== undefined)
      safari.map((sfr) => {
        if (sfr?.title.toString().toLowerCase().includes(key))
          return searchArray.push(sfr);
        return true;
      });

    setSafarisList(searchArray);
    if (key === "") setSafarisList(safari);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : safariList;

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.SAFARI,
      });
    }
    setLoading(false);
    reloadData();
  };

  // design tokens (compact, consistent)
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card =
    "overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-5";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `Safari`, name: entry_label }} />
        </div>

        <div className="space-y-4">
          {/* Search + Add */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <MySearch
                type={_TYPES_.SAFARI}
                value={localSearch}
                showGlobalSearch={true}
                setValue={setLocalSearch}
                onChange={(e) => SearchList(e)}
              />

              {country_id ? (
                <Link to={addRoute} className="shrink-0">
                  <MyButton
                    title="Add Safari"
                    className={`${btnBase} ${btnPrimary}`}
                    onClick={() => { }}
                  />
                </Link>
              ) : null}
            </div>
          </div>

          {/* Bulk actions */}
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-wrap items-center gap-3">
              <MyButton className={`${btnBase} ${btnNeutral}`}>
                {selectedContentIds?.length === LocalData?.length &&
                  LocalData?.length > 0 ? (
                  <FaRegCheckSquare
                    onClick={() => setSelectedContentIds([])}
                    className="text-green-600 text-lg cursor-pointer"
                    aria-label="Unselect all"
                  />
                ) : (
                  <FaRegSquare
                    onClick={() => {
                      const ids = LocalData?.map((safari) => safari?.safari_id);
                      setSelectedContentIds(ids || []);
                    }}
                    className="text-slate-700 text-lg cursor-pointer"
                    aria-label="Select all"
                  />
                )}
                <span className="text-slate-700">
                  {selectedContentIds.length === LocalData?.length &&
                    LocalData?.length > 0
                    ? "Unselect All"
                    : "Select All"}
                </span>
              </MyButton>

              <MyButton
                onClick={deleteMany}
                className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                  }`}
                disabled={selectedContentIds?.length === 0 || loading}
              >
                {loading ? (
                  <RiRefreshLine className="text-lg animate-spin" />
                ) : (
                  <FaRegTrashAlt className="text-base" />
                )}
                <span>
                  Delete{" "}
                  {selectedContentIds?.length > 0 ? selectedContentIds.length : ""}{" "}
                  {selectedContentIds?.length === 1 ? "Item" : "Items"}
                </span>
              </MyButton>
            </div>
          </div>

          {/* Table */}
          <div className={card}>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-700 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold w-[120px]">
                      Select
                    </th>
                    <th className="px-4 py-3 text-left font-semibold w-1/2">
                      Title
                    </th>
                    <th className="px-4 py-3 text-left font-semibold w-1/4">
                      Slug
                    </th>
                    <th className="px-4 py-3 text-center font-semibold w-[220px]">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {safari || LocalData ? (
                    LocalData?.map((sfr, key) => (
                      <tr
                        key={key}
                        className="hover:bg-slate-50 transition-colors"
                      >
                        <td className="px-4 py-3">
                          {selectedContentIds.includes(sfr?.safari_id) ? (
                            <MyButton
                              onClick={() => {
                                const filteredIds = selectedContentIds.filter(
                                  (id) => id !== sfr?.safari_id
                                );
                                setSelectedContentIds(filteredIds);
                              }}
                              className={`${btnBase} ${btnNeutral}`}
                            >
                              <FaRegCheckSquare className="text-green-600 text-lg" />
                            </MyButton>
                          ) : (
                            <MyButton
                              onClick={() =>
                                setSelectedContentIds([
                                  ...selectedContentIds,
                                  sfr?.safari_id,
                                ])
                              }
                              className={`${btnBase} ${btnNeutral}`}
                            >
                              <FaRegSquare className="text-slate-700 text-lg" />
                            </MyButton>
                          )}
                        </td>
                        <td className="px-4 py-3">{sfr?.title}</td>
                        <td className="px-4 py-3">{sfr?.slug}</td>
                        <td className="px-2 py-3">
                          <ActionButton props={sfr} reloadData={reloadData} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className={`${card} ${sectionPad}`}>
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={safariCount}
              callbackFunction={(p, size) => {
                fetchDoSeeData(data_request_body, p, size);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { safari, deleteOneContent, updateOneContent } = useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const safari_id = props.safari_id;
  const safari_title = props.title;
  const sfr = props;

  const deleteOneSafariById = async (safari_id) => {
    const { status } = await deleteOneContent({
      data_id: safari_id,
      content: _TYPES_.SAFARI,
    });

    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      promoted: `${position}`,
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
    };
  };

  const promotion = async (position) => {
    const previousPromoted = safari?.find(
      (safari) => safari?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: sfr?.safari_id,
      data: buildData(props, position),
      content: _TYPES_.SAFARI,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.safari_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.SAFARI,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (sfr) => {
    const data = {
      country_id: sfr?.country_id,
      description: sfr?.description,
      first_level_id: sfr?.first_level_id,
      fourth_level_id: sfr?.fourth_level_id,
      second_level_id: sfr?.second_level_id,
      slug: sfr?.slug,
      status: sfr?.status === 1 ? 0 : 1,
      third_level_id: sfr?.third_level_id,
      thumbnail: sfr?.thumbnail,
      title: sfr?.title,
    };

    const { status } = await updateOneContent({
      data_id: sfr?.safari_id,
      data: data,
      content: _TYPES_.SAFARI,
    });

    if (status === 200) {
      reloadData();
    }
  };

  const btnBase =
    "inline-flex items-center gap-2 px-3 py-2 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 text-xs";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <>
      <Modal
        props={{
          name: safari_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneSafariById(safari_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={safari
          ?.filter(
            (safari) =>
              !["yes", "no", null, undefined].includes(safari?.promoted)
          )
          .map((safari) => ({
            id: safari?.safari_id,
            title: safari?.title,
            position: parseInt(safari?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={sfr?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`${btnBase} ${sfr?.status === 1 ? btnPrimary : btnWarn}`}
              onClick={() => suspension(sfr)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(sfr?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`${btnBase} ${["yes", "no", null, undefined].includes(sfr?.promoted)
                ? btnNeutral
                : btnWarn
                }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneSafari(sfr)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
